import * as React from "react";
import {
  TextField,
  FunctionField,
  DateField,
  EditButton,
  TextInput,
  SelectInput,
} from "react-admin";
import { StatusEnum } from "src/common/enum";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";

const listFilters = [
  <TextInput source="search" label="Search" alwaysOn />,
  <SelectInput source="status" choices={StatusEnum} />,
];

export const SampleSubscriberList = (props) => {
  return (
    <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="email" label="Email" />
        <FunctionField label="User" render={record => record.user ? record.user.first_name+" "+record.user.last_name : "" }/>
        <TextField source="note" label="Note" />
        <FunctionField label="Product" render={record => record.product.name+" "+record.product.sku}/>
        <FunctionField
          label="Status"
          source="status"
          render={(record) =>
            StatusEnum.find((x) => x.id === record.status)?.name
          }
        />
        <DateField source="created_at" label="Created At" />
        <IfCanAccess action="edit">
          <EditButton />
        </IfCanAccess>
      </Datagrid>
    </List>
  );
};
